import React, { useState, useEffect, useReducer } from 'react';
import useAuth from '../../../hooks/useAuth';
import { Helmet } from 'react-helmet';
import { Link, Redirect, useNavigate } from 'react-router-dom';
import useGlobalStore from '../../../hooks/useGlobalStore';
import _ from "lodash";
// import { AllUserSearchAccountList, ChangeStatusAccount, ChangeStatusForMacSettingsApi, DeleteAnyAccount } from '../../../actions/authAction';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import LoadingScreen from '../../../components/LoadingScreen';
import ToastHot from 'react-hot-toast';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Reducer from '../../../services/Reducer';
import { GetAccountList } from '../../../actions/authAction';
import { Avatar, Box, Grid, IconButton, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { BsPaypal } from "react-icons/bs";
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const initState = {
    searchTerm: '',
    listingData: [],
    totalItem: '',
    loading: false,
    validate: false
};

export default function AllAccount() {
    const [state, dispatch] = useReducer(Reducer, initState);
    const [value, setValue] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [limit] = React.useState(10);
    const [userType, setUserType] = React.useState('DJ');
    const navigator = useNavigate()

    const handleChange = (event, newValue) => {

        setValue(newValue);
        if (newValue == 0) {
            setUserType('DJ')
        } else if (newValue == 1) {
            setUserType('ORGANIZER')
        } else {
            setUserType('ATTENDEE')
        }
    };

    const handleChangePage = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        getFilterwithPaginationList()
    }, [page, state.searchTerm, userType]);

    const getFilterwithPaginationList = async () => {
        dispatch({ type: 'LOAD', payload: true });
        const response = await GetAccountList(page, limit, userType, state.searchTerm);
        if (response && response.data) {
            // setIsError(true)
            if (response.status === 200) {
                dispatch({ type: 'LOAD', payload: false });
                dispatch({ type: "SETDATA", payload: { "name": "listingData", "value": response.data.data.rows } })
                dispatch({ type: "SETDATA", payload: { "name": "totalItem", "value": response.data.data.totalCount } })
            } else {
                dispatch({ type: 'LOAD', payload: false });
                dispatch({ type: "SETDATA", payload: { "name": "listingData", "value": [] } })
                dispatch({ type: "SETDATA", payload: { "name": "totalItem", "value": 0 } })
            }

        } else {
            dispatch({ type: 'LOAD', payload: false });
            ToastHot.error('Something went wrong')
            // toast.error("Something went wrong");
        }
    }
    const popUpForConfirmation = (index, deletedData, type) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    // default-alert-popup
                    // danger-alert-popup
                    // success-alert-popup
                    <div className='custom-ui-alert-popup default-alert-popup'>
                        <div className="alert-popup-headerpart">
                            <h1>Are you sure?</h1>
                            <div className="alert-popup-close" onClick={onClose} >X</div>
                        </div>
                        <div className="alert-popup-bodypart">
                            <p>You want to {type && type === 'delete' ? type : deletedData.status && deletedData.status === 'A' ? 'Inactive' : 'Active'} this account?</p>
                        </div>
                        <div className="alert-actions">
                            <div className="alert-actions-col">
                                <button onClick={onClose} className="alert--cancel-btn">No</button>
                            </div>
                            <div className="alert-actions-col">
                                {type && type === 'delete' ?
                                    <button className="alert--submit-btn"
                                        onClick={() => {
                                            deleteContact(index, deletedData)
                                            onClose();
                                        }}
                                    >
                                        Yes, Delete it!
                                    </button>
                                    :
                                    <></>
                                }
                            </div>
                        </div>
                    </div>
                );
            }
        });
    }
    const deleteContact = async (index, deletedData) => {
        let delId = deletedData.id
        const response = false//await DeleteAnyAccount(delId);
        if (response && response.status === 200) {
            ToastHot.success('Account has been successfully deleted.')
            getFilterwithPaginationList()
        } else {
            ToastHot.error('Something went wrong')
        }
    }

    const debounce = (func) => {
        let timer;
        return function (...args) {
            const context = this;
            if (timer) clearTimeout(timer)
            timer = setTimeout(() => {
                timer = null
                func.apply(context, args);
            }, 500);
        }
    }
    const phoneNumberFormat = (value) => {
        let x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        console.log(value)
        return value
    }
    const handleChangeSearch = (e) => {
        console.log(e)
        const { value } = e.target;
        dispatch({ type: "SETDATA", payload: { "name": "searchTerm", "value": decodeURI(value) } })
    }
    const optimizedVersion = React.useCallback(debounce(handleChangeSearch), [])
    return (
        <>
            <Helmet>
                <title>Users</title>
            </Helmet>

            <div className="listingPages allAccountsPage">
                <div className="listingPagesHead">
                    <div className="left">
                        <h3>All Users</h3>
                    </div>
                    <div className="right">
                        <div className="rightInner">
                            <div className="searchGroup">
                                <div>
                                    <i className="material-icons">search</i>
                                    <input type="text" className="form-control" placeholder="Search" id="searchTerm" name="searchTerm"
                                        onChange={optimizedVersion}
                                    />
                                </div>
                            </div>
                            {/* <Link to="/user/add-admin" className="themeBtn"><i className="material-icons">add</i>Add New</Link> */}
                        </div>
                    </div>
                </div>

                <div className="listingMain">
                    <Box sx={{ borderBottom: 1, borderColor: '#0057FF' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Dj" {...a11yProps(0)} />
                            <Tab label="Event Organisers" {...a11yProps(1)} />
                            <Tab label="Event Attended" {...a11yProps(2)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        {state.loading && <LoadingScreen />}
                        <div className="customTable allaccountsTable table-responsive scrollbox">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th className='w320px'>Genres</th>
                                        <th>Bio</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>Social Account</th>
                                        <th>Connected Media</th>
                                        <th>Status</th>
                                        {/* <th>Other Details</th> */}
                                        {/* <th className="text-right">Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {!state.loading && state.listingData && state.listingData.length > 0 && state.listingData.map((listing, index) => (

                                        <tr key={index}>
                                            <td data-th="Name">
                                                <Grid container spacing={1} alignItems={'center'} onClick={() => navigator(`/user/accountPreview?id=${listing?.id}&userType=${userType}`)} sx={{ cursor: 'pointer' }}>
                                                    <Grid item>
                                                        <Avatar src={`${process.env.REACT_APP_S3_URL}${listing?.profilePicture}`} alt={listing?.firstName} style={{ backgroundColor: listing?.colorCode }} />
                                                    </Grid>
                                                    <Grid item width={'calc(100% - 48px)'}>
                                                        <Typography color={'#0057ff'} fontWeight={500}>{listing?.firstName} {listing?.lastName} <ArrowForwardRoundedIcon /></Typography>
                                                    </Grid>
                                                </Grid>
                                            </td>
                                            <td data-th="Genres" className='w320px'>{listing?.userGenreDetail?.map((item, index) => (<span key={index}>{item?.genreDetail?.name},</span>))}</td>
                                            <td data-th="Bio">
                                                <Box
                                                    maxWidth={300}
                                                    sx={{
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 3,
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        wordBreak: 'break-word', // for long words like URLs
                                                    }}
                                                >
                                                    {listing?.bio}
                                                </Box>
                                            </td>
                                            <td data-th="Phone Number">{listing?.email}</td>
                                            <td data-th="Phone Number" >{listing?.cc} {listing?.phone}</td>
                                            <td>
                                                <Box display={'flex'} >
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/youtube.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/cloud.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/instagram.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }


                                                </Box>
                                            </td>
                                            <td>

                                                {
                                                    listing?.userBankAccountDetail?.map((item, index) => (
                                                        <Grid container alignItems={'center'} gap={1}>
                                                            <Grid item>
                                                                {item?.bankType == "PAYPAL" ?
                                                                    <BsPaypal />
                                                                    :
                                                                    <AccountBalanceOutlinedIcon />
                                                                }
                                                            </Grid>
                                                            {
                                                                item?.bankType == "PAYPAL" ?
                                                                    <Grid item>
                                                                        <Typography margin={0} fontSize={14}>{item?.paypalEmail}</Typography>
                                                                    </Grid>
                                                                    :
                                                                    <Grid item>
                                                                        <Typography margin={0} fontSize={14}>{item?.bankName}</Typography>
                                                                        <Typography>xxxxxxxxxx{item?.bankAccountNumber?.slice(-2)}</Typography>
                                                                    </Grid>
                                                            }

                                                        </Grid>
                                                    ))
                                                }


                                            </td>
                                            {/* <td>
                                                <Grid container alignItems={'center'} gap={1}>
                                                    <Grid item>
                                                        <img src='/images/spotify.svg' alt='' />
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography>Spotify</Typography>
                                                    </Grid>
                                                </Grid>
                                            </td> */}
                                            {/* <td className="actionTd w60px" data-th="Action">
                                                <button class="btn dropdown-toggle" type="button">
                                                    <i class="material-icons">more_vert</i>
                                                </button>
                                            </td> */}
                                            <td data-th="Name">{listing?.userStatus||""}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {!state.loading && state.listingData && state.listingData.length === 0 &&
                                <div className="nodata-found-table">

                                    <h3>no account is still added!</h3>

                                </div>
                            }
                            {state.listingData && state.listingData.length > 0 &&
                                <div className="tablePagination">
                                    <div className="left">
                                        <p>Results {page !== 1 ? page * 10 - 9 : page} - {state.totalItem > page * 10 ? page * 10 : state.totalItem} of {state.totalItem}</p>
                                    </div>
                                    <div className="right">
                                        <div className="paginationNavigation">
                                            <nav aria-label="Page navigation example">
                                                <Stack spacing={2}>
                                                    <Pagination count={parseInt(state.totalItem % 10) === 0 ? parseInt((state.totalItem / 10)) : parseInt((state.totalItem / 10) + 1)} page={page} onChange={handleChangePage} variant="outlined" color="primary" />
                                                </Stack>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        {state.loading && <LoadingScreen />}
                        <div className="customTable allaccountsTable table-responsive scrollbox">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Genres</th>
                                        <th>Bio</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>Social Account</th>
                                        <th>Connected Media</th>
                                        <th>status</th>
                                        {/* <th>Other Details</th> */}
                                        {/* <th className="text-right">Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {state.listingData && state.listingData.length > 0 && state.listingData.map((listing, index) => (

                                        <tr key={index}>
                                            <td data-th="Name">
                                                <Grid container spacing={1} alignItems={'center'} onClick={() => navigator(`/user/accountPreview?id=${listing?.id}&userType=${userType}`)}>
                                                    <Grid item>
                                                        <Avatar src={`${process.env.REACT_APP_S3_URL}${listing?.profilePicture}`} alt={listing?.firstName} style={{ backgroundColor: listing?.colorCode }} />
                                                    </Grid>
                                                    <Grid item width={'calc(100% - 48px)'} >
                                                        <Typography color={'#0057ff'} fontWeight={500}>{listing?.firstName} {listing?.lastName} <ArrowForwardRoundedIcon /></Typography>
                                                    </Grid>
                                                </Grid>
                                            </td>
                                            <td data-th="Genres">{listing?.userGenreDetail?.map((item, index) => (<span key={index}>{item?.genreDetail?.name},</span>))}</td>
                                            <td data-th="Bio">
                                                <Box
                                                    maxWidth={300}
                                                    sx={{
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 3,
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        wordBreak: 'break-word', // for long words like URLs
                                                    }}
                                                >
                                                    {listing?.bio}
                                                </Box>
                                            </td>
                                            <td data-th="Phone Number">{listing?.email}</td>
                                            <td data-th="Phone Number" >{listing?.cc} {listing?.phone}</td>
                                            <td>
                                                <Box display={'flex'} >
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/youtube.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/cloud.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/instagram.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }


                                                </Box>
                                            </td>
                                            <td>

                                                {
                                                    listing?.userBankAccountDetail?.map((item, index) => (
                                                        <Grid container alignItems={'center'} gap={1}>
                                                            <Grid item>
                                                                {item?.bankType == "PAYPAL" ?
                                                                    <BsPaypal />
                                                                    :
                                                                    <AccountBalanceOutlinedIcon />
                                                                }
                                                            </Grid>
                                                            {
                                                                item?.bankType == "PAYPAL" ?
                                                                    <Grid item>
                                                                        <Typography margin={0} fontSize={14}>{item?.paypalEmail}</Typography>
                                                                    </Grid>
                                                                    :
                                                                    <Grid item>
                                                                        <Typography margin={0} fontSize={14}>{item?.bankName}</Typography>
                                                                        <Typography>xxxxxxxxxx{item?.bankAccountNumber?.slice(-2)}</Typography>
                                                                    </Grid>
                                                            }

                                                        </Grid>
                                                    ))
                                                }


                                            </td>
                                            {/* <td>
                                                <Grid container alignItems={'center'} gap={1}>
                                                    <Grid item>
                                                        <img src='/images/spotify.svg' alt='' />
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography>Spotify</Typography>
                                                    </Grid>
                                                </Grid>
                                            </td> */}
                                            {/* <td className="actionTd w60px" data-th="Action">
                                                <button class="btn dropdown-toggle" type="button">
                                                    <i class="material-icons">more_vert</i>
                                                </button>
                                            </td> */}
                                              <td data-th="Name">{listing?.userStatus||""}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {!state.loading && state.listingData && state.listingData.length === 0 &&
                                <div className="nodata-found-table">

                                    <h3>no account is still added!</h3>

                                </div>
                            }
                            {state.listingData && state.listingData.length > 0 &&
                                <div className="tablePagination">
                                    <div className="left">
                                        <p>Results {page !== 1 ? page * 10 - 9 : page} - {state.totalItem > page * 10 ? page * 10 : state.totalItem} of {state.totalItem}</p>
                                    </div>
                                    <div className="right">
                                        <div className="paginationNavigation">
                                            <nav aria-label="Page navigation example">
                                                <Stack spacing={2}>
                                                    <Pagination count={parseInt(state.totalItem % 10) === 0 ? parseInt((state.totalItem / 10)) : parseInt((state.totalItem / 10) + 1)} page={page} onChange={handleChangePage} variant="outlined" color="primary" />
                                                </Stack>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        {state.loading && <LoadingScreen />}
                        <div className="customTable allaccountsTable table-responsive scrollbox">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Genres</th>
                                        <th>Bio</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>Social Account</th>
                                        <th>Connected Media</th>
                                        <th>Status</th>
                                        {/* <th>Other Details</th> */}
                                        {/* <th className="text-right">Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {state.listingData && state.listingData.length > 0 && state.listingData.map((listing, index) => (

                                        <tr key={index}>
                                            <td data-th="Name">
                                                <Grid container spacing={1} alignItems={'center'} onClick={() => navigator(`/user/accountPreview?id=${listing?.id}&userType=${userType}`)}>
                                                    <Grid item >
                                                        <Avatar src={`${process.env.REACT_APP_S3_URL}${listing?.profilePicture}`} alt={listing?.firstName} style={{ backgroundColor: listing?.colorCode }} />
                                                    </Grid>
                                                    <Grid item width={'calc(100% - 48px)'}>
                                                        <Typography color={'#0057ff'} fontWeight={500}>{listing?.firstName} {listing?.lastName} <ArrowForwardRoundedIcon /></Typography>
                                                    </Grid>
                                                </Grid>
                                            </td>
                                            <td data-th="Genres">{listing?.userGenreDetail?.map((item, index) => (<span key={index}>{item?.genreDetail?.name},</span>))}</td>
                                            <td data-th="Bio">
                                                <Box
                                                    maxWidth={300}
                                                    sx={{
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 3,
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        wordBreak: 'break-word', // for long words like URLs
                                                    }}
                                                >
                                                    {listing?.bio}
                                                </Box>
                                            </td>
                                            <td data-th="Phone Number">{listing?.email}</td>
                                            <td data-th="Phone Number" >{listing?.cc} {listing?.phone}</td>
                                            <td>
                                                <Box display={'flex'} >
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Youtube')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/youtube.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Sound Cloud')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/cloud.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }
                                                    {
                                                        listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram').length > 0
                                                        &&
                                                        <Link to={`${listing?.userSocialChannelDetail?.filter((it) => it?.label == 'Instagram')[0]?.link}`} target="_blank">
                                                            <IconButton><img src='/images/instagram.svg' alt='' /></IconButton>
                                                        </Link>
                                                    }


                                                </Box>
                                            </td>
                                            <td>
                                                <Grid container alignItems={'center'} gap={1}>
                                                    {
                                                        listing?.userBankAccountDetail?.map((item, index) => (
                                                            <>
                                                                <Grid item>
                                                                    {item?.bankType == "PAYPAL" ?
                                                                        <BsPaypal />
                                                                        :
                                                                        <AccountBalanceOutlinedIcon />
                                                                    }
                                                                </Grid>
                                                                {
                                                                    item?.bankType == "PAYPAL" ?
                                                                        <Grid item>
                                                                            <Typography margin={0} fontSize={14}>{item?.paypalEmail}</Typography>
                                                                        </Grid>
                                                                        :
                                                                        <Grid item>
                                                                            <Typography margin={0} fontSize={14}>{item?.bankName}</Typography>
                                                                            <Typography>xxxxxxxxxx{item?.bankAccountNumber?.slice(-2)}</Typography>
                                                                        </Grid>
                                                                }

                                                            </>
                                                        ))
                                                    }

                                                </Grid>
                                            </td>
                                            {/* <td>
                                                <Grid container alignItems={'center'} gap={1}>
                                                    <Grid item>
                                                        <img src='/images/spotify.svg' alt='' />
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography>Spotify</Typography>
                                                    </Grid>
                                                </Grid>
                                            </td> */}
                                            {/* <td className="actionTd w60px" data-th="Action">
                                                <button class="btn dropdown-toggle" type="button">
                                                    <i class="material-icons">more_vert</i>
                                                </button>
                                            </td> */}
                                             <td data-th="Name">{listing?.userStatus||""}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {!state.loading && state.listingData && state.listingData.length === 0 &&
                                <div className="nodata-found-table">

                                    <h3>no account is still added!</h3>

                                </div>
                            }
                            {state.listingData && state.listingData.length > 0 &&
                                <div className="tablePagination">
                                    <div className="left">
                                        <p>Results {page !== 1 ? page * 10 - 9 : page} - {state.totalItem > page * 10 ? page * 10 : state.totalItem} of {state.totalItem}</p>
                                    </div>
                                    <div className="right">
                                        <div className="paginationNavigation">
                                            <nav aria-label="Page navigation example">
                                                <Stack spacing={2}>
                                                    <Pagination count={parseInt(state.totalItem % 10) === 0 ? parseInt((state.totalItem / 10)) : parseInt((state.totalItem / 10) + 1)} page={page} onChange={handleChangePage} variant="outlined" color="primary" />
                                                </Stack>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </CustomTabPanel>


                </div>
            </div>





        </>
    );
}
